import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Input } from 'reactstrap';
import { useBrand } from './BrandProvider';

export function BrandSwitcher() {
  const brand = useBrand();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  if (brand.brands.length === 0) return null;

  return (
    <Input
      type="select"
      bsSize="sm"
      value={brand.currentBrand?.slug ?? ''}
      onChange={(e) => {
        const nextSlug = e.target.value;
        const ok = brand.setCurrentBrandSlug(nextSlug);
        if (!ok) return;
        if (params.brandSlug && params.brandSlug !== nextSlug) {
          const newPath = location.pathname.replace(`/${params.brandSlug}`, `/${nextSlug}`);
          navigate(newPath, { replace: true });
        } else if (!params.brandSlug && !location.pathname.startsWith('/admin')) {
          navigate(`/${nextSlug}/dashboard`, { replace: true });
        }
      }}
      style={{ maxWidth: 180 }}
      aria-label="Brand auswählen"
    >
      {brand.brands.map((b) => (
        <option key={b.brandOrigin} value={b.slug}>
          {b.displayName}
        </option>
      ))}
    </Input>
  );
}
